import React from 'react';
import { MicrosoftFilesNode } from '../microsoftFiles';
export function OneDrive(props: any) { return <MicrosoftFilesNode {...props} provider="onedrive"/>; }
